import ActionTypes from "../Actions/ActionTypes"

const initialState = { 
    schedule: []
}

const ScheduleReducer = (state =  initialState, action) => {
     switch(action.type){
        case ActionTypes.GET_SCHEDULE:
            state = {...state, schedule: action.payload}
        break;
         default:
      break;
     }
     return state   
}
export default ScheduleReducer;